import React from 'react'

const Icon = (props) => (
  <svg
    width={39}
    height={16}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path id="a" d="M.329.37h22.708v12.932H.33z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M21.74 9.556c3.535-.793 6.55-2.46 8.982-4.95l-3.383-1.94c-2.03 1.98-4.907 3.839-8.882 4.667-5.21 1.088-8.495 3.93-10.402 6.286l3.379 1.937c2.538-2.994 6.022-5.036 10.306-6"
        fill="#818285"
      />
      <path
        d="M24.471 12.415c3.952-.876 7.25-2.752 9.807-5.578l-3.345-1.948c-2.506 2.655-5.627 4.44-9.298 5.262-4.698 1.052-7.357 3.473-7.357 3.473l3.315 1.932c1.76-1.35 4.01-2.512 6.878-3.141M15.66.444c-1.222.564-2.528.988-3.916 1.26C6.04 2.82 2.518 6.002.566 8.476c-.18.228-.348.453-.51.677l3.39 1.958c.07-.099.144-.194.222-.292 1.785-2.312 3.975-4.119 6.46-5.353 2.564-1.273 4.284-1.393 6.034-1.886 1.96-.549 3.005-1.123 3.005-1.123L15.659.444"
        fill="#818285"
      />
      <g transform="translate(3.611)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          d="M14.573 6.687c3.76-.786 6.503-2.522 8.464-4.388L19.672.37s-2.996 3.052-8.3 4.084C3.897 5.908.384 11.312.328 11.387l3.343 1.915c2.239-2.787 5.718-5.537 10.901-6.615"
          fill="#818285"
          mask="url(#b)"
        />
      </g>
      <path
        d="m38.278 9.055-3.301-1.944a18.264 18.264 0 0 1-6.762 4.84c-2.492 1.038-3.892 1.051-5.048 1.501l3.558 2.104c.195-.051 7.197-1.001 11.553-6.5"
        fill="#818285"
      />
    </g>
  </svg>
)

export default () => {
  return (
    <>
      
    </>
  )
}
